import React from "react";
import automation from "../../images/LandingPageImage/web_campaign_broadcast_1x.webp";
import templateDesign from "../../images/LandingPageImage/web_chat_bot_1x.webp";

export default function FeatureSection() {
  return (
    <section
      className="flex flex-col font-inter justify-center bg-white 
      px-4 sm:px-5 md:px-8 lg:px-16 xl:px-40"
    >
      <div className="text-center pt-8 lg:pt-12 text-heading-blue">
        <h1 className="text-3xl md:text-4xl font-medium">Features</h1>
      </div>

      <div className="max-w-225 mx-auto text-center text-text-secondary pt-4">
        <p className="text-lg py-2 mb-8">
          Enhance customer engagement and streamline operations with powerful
          WhatsApp campaigns and intelligent chatbots. Efficiently Manage
          Inquiries and Updates through a Unified Inbox and Seamless
          Integrations.
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-8 md:gap-10 mb-12">
        <div
          className="flex flex-col p-6 gap-4 bg-brand-light items-center text-center justify-start 
           rounded-xl border border-transparent hover:border-blue-100 transition-all
          flex-[1_1_350px] lg:flex-[1_1_420px] max-w-200"
        >
          <div className="text-xl md:text-2xl font-semibold p-2 lg:pt-0 text-heading-blue">
            Campaign Automation & Management
          </div>

          <div className="flex justify-center w-full">
            <img
              loading="lazy"
              src={automation}
              alt="Automation features"
              className="max-w-full h-auto block rounded-lg shadow-sm"
            />
          </div>

          <ul className="list-disc space-y-2 mt-4 px-4 text-start text-text-secondary">
            <li>Streamline WhatsApp campaigns for effortless communication.</li>
            <li>
              Schedule personalized messages to connect at the right moment.
            </li>
            <li>
              Boost engagement with timely, relevant updates—no manual effort.
            </li>
          </ul>
        </div>

        <div
          className="flex flex-col p-6 gap-4 bg-brand-light items-center text-center justify-start 
          rounded-xl border border-transparent hover:border-blue-100 transition-all
          flex-[1_1_350px] lg:flex-[1_1_420px] max-w-200"
        >
          <div className="text-xl md:text-2xl font-semibold p-2 lg:pt-0 text-heading-blue">
            Template Design
          </div>

          <div className="flex justify-center w-full">
            <img
              loading="lazy"
              src={templateDesign}
              alt="Template design"
              className="max-w-full h-auto block rounded-lg shadow-sm"
            />
          </div>

          <ul className="list-disc space-y-2 mt-4 px-4 text-start text-text-secondary">
            <li>Create professional templates tailored to your audience.</li>
            <li>Customize to match your brand’s voice.</li>
            <li>
              Increase open/response rates with targeted, impactful messages.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
